package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import org.moxultimate.topwithmox.architecture.ui.ArchitecturePage
import org.moxultimate.topwithmox.components.layouts.PageLayoutData

@InitRoute
fun initArchitectureRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Architecture"))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun ArchitectureRoute() {
    ArchitecturePage()
}
